exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.cart-summary .product__action[data-v-781b1d29] {\n  margin: 15px 0 0 auto;\n  display: flex;\n  width: 50%;\n}\n.cart-summary .product__action .btn[data-v-781b1d29] {\n    margin: 0;\n}\n@media screen and (max-width: 768px) {\n.cart-summary .product__action[data-v-781b1d29] {\n    width: 100%;\n}\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-781b1d29","scoped":true,"hasInlineConfig":false}!./~/sass-loader/lib/loader.js?{"includePaths":["/Users/noomz/Projects/Opendream/kadnud/kadnud-eef-app/src/css"],"sourceMap":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/Cart.vue
// module id = 591
// module chunks = 1